﻿import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { IRootScope } from "@models";

@NgComponent({
    token: Token.KbSpinner,
    dependencies: [
        Token.$Http,
        Token.$Compile,
        Token.$RootScope,
    ]
})
export class KbSpinner extends Directive {
    constructor(
        private $http: ng.IHttpService,
        private $compile: ng.ICompileService,
        private $rootScope: IRootScope
    ) {
        super();

        this.restrict = "A";
        this.scope = true;

        this.link = (scope: any, element, atts: any) => {
            scope._tracker = scope.$eval(atts.kbSpinner);

            // get the template
            let template: string = "<div ng-show='_tracker.active()' class='kb-cube kb-fade'>" +
                "<div class='kb-cube__cloak'></div>" +
                "<div class='kb-cube__cube'>" +
                "<div class='kb-cube__face kb-cube__one'></div>" +
                "<div class='kb-cube__face kb-cube__two'></div>" +
                "<div class='kb-cube__face kb-cube__three'></div>" +
                "<div class='kb-cube__face kb-cube__four'></div>" +
                "<div class='kb-cube__face kb-cube__five'></div>" +
                "<div class='kb-cube__face kb-cube__six'></div>" +
                "</div>" +
                "</div>";

            let templateElement = $compile(template)(scope);

            element.append(templateElement);
        };

    }
}
